import React, { useState } from 'react'
import InputFieldDefault from './InputFieldDefault';
import InputFieldSelect from './InputFieldSelect';

const InputFieldPeriod = (props) => {
    const { config, onChange, defaultValue } = props;
    const [value, setValue] = useState(defaultValue.value || '');
    const [periodType, setPeriodType] = useState(defaultValue.period_type || '');

    const handleChange = (name, val) => {
        let responseValue = value;
        let responsePeriodType = periodType;
        if (name === 'value') {
            responseValue = val;
            setValue(val);
        } else if (name === 'period_type') {
            responsePeriodType = val;
            setPeriodType(val);
        }
        if (onChange) {
            onChange({ value: responseValue, period_type: responsePeriodType }, config.name);
        }
    }

    return (
        <>
            <InputFieldDefault config={config} onChange={(val) => handleChange('value', val)} />
            <InputFieldSelect config={{ options: config.period_types }} onChange={(val) => handleChange('period_type', val)} />
        </>
    )
}

export default InputFieldPeriod